
import $ from 'jquery';

import Immutable from 'immutable';
import Fluxxor from 'fluxxor';

import moment from 'ofs/moment';


var BookingQuoteStore = Fluxxor.createStore({
  actions: {
    COMPLETE_CALENDAR_RANGE_SELECTION: 'onRangeSelection',
    BOOKING_QUOTE_UPDATE: 'onBookingQuoteUpdate',
    BOOKING_QUOTE_ERROR: 'onBookingQuoteError'
  },

  initialize(options) {
    this.setMaxListeners(0);
    this.state = Immutable.fromJS(options);

    if (this.state.get('startDate')) {
      this.state = this.state.set('startDate', moment(this.state.get('startDate'), 'YYYY-MM-DD'));
    }
    if (this.state.get('endDate')) {
      this.state = this.state.set('endDate', moment(this.state.get('endDate'), 'YYYY-MM-DD'));
    }

    if (this.state.get('startDate') && this.state.get('endDate')) {
      this.state = this.state.set('range', moment().range(this.state.get('startDate'), this.state.get('endDate')));
    } else {
      this.state = this.state.set('range', null);
    }
  },

  onRangeSelection(payload) {
    this.state = this.state.withMutations(function(s) {
      s
        .set('range', payload.range)
        .set('bookable', false)
        .set('quoteData', null)
        .set('loading', true);
    });

    this.emit('change');

    this.updateQuote();
  },

  onBookingQuoteUpdate(payload) {
    this.state = this.state.withMutations(function(s) {
      s
        .set('quoteData', payload.data)
        .set('bookable', !payload.data['error_msg'])
        .set('loading', false);
    });
    this.emit('change');
  },

  onBookingQuoteError() {
    this.state = this.state.withMutations(function(s) {
      s
        .set('quoteData', null)
        .set('bookable', false)
        .set('loading', false);
    });
    this.emit('change');
  },

  getFormattedStartDate() {
    if (this.state.get('range')) {
      return this.state.get('range').start.format('D MMMM YYYY');
    }
    return null;
  },

  getFormattedEndDate() {
    if (this.state.get('range')) {
      return this.state.get('range').end.format('D MMMM YYYY');
    }
    return null;
  },

  getISO8601StartDate() {
    if (this.state.get('range')) {
      return this.state.get('range').start.format('YYYY-MM-DD');
    }
    return null;
  },

  getISO8601EndDate() {
    if (this.state.get('range')) {
      return this.state.get('range').end.format('YYYY-MM-DD');
    }
    return null;
  },

  updateQuote() {
    var startDate = this.getISO8601StartDate();
    var endDate = this.getISO8601EndDate();

    if (startDate && endDate) {
      $.ajax({
        url: this.state.get('quoteUrl'),
        method: 'POST',
        data: {
          'start_date': startDate,
          'end_date': endDate,
          'page': 'summary'
        },
        success: this.flux.actions.quote.update,
        error: this.flux.actions.quote.error
      });
    }
  }
});

export default BookingQuoteStore;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/legacy/property/default/stores/BookingQuoteStore.js
 **/